/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The JobProofLinkResponse model module.
 * @module model/JobProofLinkResponse
 * @version V1
 */
class JobProofLinkResponse {
    /**
     * Constructs a new <code>JobProofLinkResponse</code>.
     * @alias module:model/JobProofLinkResponse
     */
    constructor() { 
        
        JobProofLinkResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>JobProofLinkResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/JobProofLinkResponse} obj Optional instance to populate.
     * @return {module:model/JobProofLinkResponse} The populated <code>JobProofLinkResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new JobProofLinkResponse();

            if (data.hasOwnProperty('success')) {
                obj['success'] = ApiClient.convertToType(data['success'], 'Boolean');
            }
            if (data.hasOwnProperty('addedCount')) {
                obj['addedCount'] = ApiClient.convertToType(data['addedCount'], 'Number');
            }
            if (data.hasOwnProperty('removedCount')) {
                obj['removedCount'] = ApiClient.convertToType(data['removedCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>JobProofLinkResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>JobProofLinkResponse</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Boolean} success
 */
JobProofLinkResponse.prototype['success'] = undefined;

/**
 * @member {Number} addedCount
 */
JobProofLinkResponse.prototype['addedCount'] = undefined;

/**
 * @member {Number} removedCount
 */
JobProofLinkResponse.prototype['removedCount'] = undefined;






export default JobProofLinkResponse;

